import OfflineIndex from '@rebuild/materials/shared/investment_activity/OfflineIndex.vue';

export const componentMap = {
	full: OfflineIndex
};
